import { usePresentationReadOnly } from '@mentimeter/presentation-state';
import { usePresentationLocalStore } from '../../presentation-state';

export const useCurrentSlideState = () => {
  const slideStates = usePresentationReadOnly(
    ({ state }) => state?.slideStates,
  );
  const localId = usePresentationLocalStore((state) => state.localId);
  return localId && slideStates ? slideStates[localId] : undefined;
};
